import { createAsyncThunk } from "@reduxjs/toolkit";

import { handleErrors, type ApiError } from "../../../api/errorUtils";
import type {
  FavoriteRequest,
  ProfileViewerRequest,
  SitterResponse,
  SittersParams,
  SittersResponse,
  TrendingParams,
  TrendingResponse,
} from "../ts";

export const generateMockSitters = (count = 10) => {
  const names = [
    "Manoj Prasad",
    "Shing Yee",
    "Arita",
    "Krystal",
    "Daniel",
    "Ayesha",
    "Ryan",
    "Mei Ling",
    "Joshua",
    "Priya",
  ];

  return Array.from({ length: count }).map((_, i) => ({
    id: i + 1,
    name: names[i % names.length],
    username: `user${i + 1}`,
    image: `https://i.pravatar.cc/300?img=${(i % 70) + 1}`,
    description:
      "I am a loving and responsible pet sitter with hands-on experience caring for both dogs and cats. I understand that every pet has a unique personality, routine, and comfort level, and I take the time to get to know their needs. My goal is to ensure your pet feels safe, relaxed, and well cared for while you’re away.",
    distance: `${(Math.random() * 10).toFixed(1)} km`,
    price: Math.floor(Math.random() * 20) + 8,
    rating: Number((Math.random() * 2 + 3).toFixed(1)),
    reviews: Math.floor(Math.random() * 120) + 5,
    profile_handler: names[i % names.length].replaceAll(" ", "_"),
    headline: "A loving and responsible pet sitter dedicated to providing high-quality, personalized care."
  }));
};

export const GetTopSittersThunk = createAsyncThunk<
  SittersResponse,
  SittersParams
>("sitters/get_top_sitters_thunk", async (_, thunkAPI) => {
  try {
    await new Promise((res) => setTimeout(res, 500));

    return {
      results: generateMockSitters(20),
      count: 20,
      previous: "",
      next: "True",
    } as unknown as SittersResponse;
  } catch (err: unknown) {
    return handleErrors(err as ApiError, thunkAPI);
  }
});

export const GetSitterThunk = createAsyncThunk<SitterResponse, string>(
  "sitters/get_sitter_thunk",
  async (_, thunkAPI) => {
    try {
      return {} as SitterResponse;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const GetTrendingThunk = createAsyncThunk<
  TrendingResponse,
  TrendingParams
>("sitters/get_trending_thunk", async (_, thunkAPI) => {
  try {
    return {} as TrendingResponse;
  } catch (err: unknown) {
    return handleErrors(err as ApiError, thunkAPI);
  }
});

export const CreateFavoriteThunk = createAsyncThunk<void, FavoriteRequest>(
  "sitters/create_favorite_thunk",
  async (_, thunkAPI) => {
    try {
      console.log("test");
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const RemoveFavoriteThunk = createAsyncThunk<void, string>(
  "sitters/remove_favorite_thunk",
  async (_, thunkAPI) => {
    try {
      console.log("test");
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  },
);

export const CreateProfileViewerThunk = createAsyncThunk<
  void,
  ProfileViewerRequest
>("sitters/create_profile_viewer_thunk", async (_, thunkAPI) => {
  try {
    console.log("");
  } catch (err: unknown) {
    return handleErrors(err as ApiError, thunkAPI);
  }
});

const searchThunk = {
  GetTopSittersThunk,
  GetSitterThunk,
  GetTrendingThunk,
  CreateFavoriteThunk,
  RemoveFavoriteThunk,
  CreateProfileViewerThunk,
};
export default searchThunk;
